import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#0d0b14]" data-id="element-45">
      <div className="max-w-3xl mx-auto" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/[0.05] backdrop-blur-sm rounded-3xl p-8 sm:p-12 border border-white/10 text-center flex flex-col items-center" data-id="element-47">
          <div className="w-20 h-20 bg-pink-500/20 rounded-full flex items-center justify-center mb-6" data-id="element-48">
            <ShieldCheck className="w-10 h-10 text-pink-400" data-id="element-49" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-50">
            Pruébalo sin riesgo.
          </h2>
          <p className="text-xl font-semibold text-slate-200 mb-4" data-id="element-51">
            Tienes 7 días de garantía.
          </p>
          <p className="text-lg text-slate-400 max-w-xl" data-id="element-52">
            Si sientes que este sistema no era para ti, puedes solicitar tu
            reembolso dentro del plazo establecido. Sin preguntas complicadas.
          </p>
        </motion.div>
      </div>
    </section>;
}